"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = audioOutputDevice;
var _types = require("../../actions/meeting/types");
function audioOutputDevice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_SET_AUDIO_OUTPUT_DEVICE, "_SUCCESS")) {
    return action.payload;
  }
  return state;
}